import {Component} from '@angular/core';
import {BaseModalComponent} from "./base_modal.component";

@Component({
	selector: 'info-modal',
	template: `<base-modal
			[title]="title"
			[isLoading]="isLoading"
			[btnOkClass]="btnOkClass"
			[btnOkLabel]="btnOkLabel"
			[btnCloseDisplay]="false"
			(onOk)="ok()"
	>
		<ng-content></ng-content> 
	</base-modal>`
})
export class InfoModalComponent extends BaseModalComponent {
	ok() {
		this.onOk.emit();
	}
}
